<template>
    <div>
        <ctlHomeNav></ctlHomeNav>
        <v-container>
            <v-card>
                <v-toolbar dark color="secondary">
                    <v-spacer></v-spacer>                
                    <v-toolbar-title>Reassign ZIPs</v-toolbar-title>
                    <v-spacer></v-spacer>    
                    <!-- {{isHMInternalSite}}             -->
                    <!-- {{id}} -->
                    <!-- <v-btn small 
                        v-if="userHasSysAdminRole"
                        to="/admin/rep-new" color="primary">Add New Rep</v-btn> -->
                </v-toolbar>
                <!-- <v-layout row v-if="error">
                    <v-flex xs12>
                        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
                    </v-flex>
                </v-layout>   -->
                <v-card-text>
                    <v-layout row>
                        <v-flex xs3 pl-1>
                            <v-select 
                            label="State"
                            :rules="[]"
                            v-bind:items="usStates"
                            v-model="paras.state"
                            item-text="name"
                            item-value="abbreviation"
                            hint=""
                            persistent-hint
                            ></v-select>

                        </v-flex>
                        <v-flex xs3 pl-1>
                            <v-select 
                            label="Territory Type"
                            :rules="[]"
                            v-bind:items="['Standard', 'GI']"
                            v-model="paras.territoryTypeInMap"
                            hint=""
                            persistent-hint
                            ></v-select>

                        </v-flex>
                        <v-flex xs3>
                            <v-btn color="primary" @click="onPopulateMap">Submit</v-btn>
                        </v-flex>
                    </v-layout>
                <!-- </v-card-text>
                <v-card-text> -->
                    <v-item-group multiple>
                        <v-subheader>Facility Marks</v-subheader>
                        <v-item
                            v-for="n in territories"
                            :key="n.id"
                        >
                                <v-chip slot-scope="{ active, toggle }" outline>
                                    <v-avatar>
                                    <img :src="n.iconUrl" alt="">
                                    </v-avatar>
                                    {{ n.id }} ({{ n.customerQty }})
                                </v-chip>
                            <div class="text-xs-center">
                            </div>
                        
                        </v-item>
                    </v-item-group>
                </v-card-text>
                <v-card-text>
                    <!-- <v-layout row>
                        <v-flex xs12>
                            <v-alert
                            :value="true"
                            type="error"
                            >
                            All $ amount in this page are FAKE value, just for demo purpose.
                            </v-alert>
                        </v-flex>
                    </v-layout> -->
                    <v-layout row>
                        <v-flex xs12>
                            <div id="divmap"  class="App"/>
                        </v-flex>
                    </v-layout>

                </v-card-text>
                <v-card-text>
                    <v-card color="warning">
                        <v-card-title>
                            <div class="headline">How to use ZIP Reassign Tool</div>
                        </v-card-title>
                        <v-card-text>
                            <ol>
                                <li>Copy Comma Separated ZIPs and Paste to ZIPs To Reassign Text Box.</li>
                                <li>Or Click any ZIP Polygon in Map and it will be appended to ZIPs To Reassign Text Box. </li>
                                <li>If you want to add a new ZIP code distribution, Click Button ADD NEW ZIP CODE ASSIGNMENT.</li>
                                <li>After you have ZIPs Ready in Text Box ZIPs to Reaasign, 
                                    Click Button Assign ZIPs, then Map will be updated.
                                    Also, all ZIPs in Text Box ZIPS To Reassign will be added to this section.</li>
                            </ol>
                        </v-card-text>
                        <v-card-text>
                            <v-layout row>
                                <v-flex xs2>
                                    <b>ZIPs To Reassign:</b>
                                    <div>
                                        (USE COMMA TO SEPARATE EACH ZIP)
                                    </div>
                                </v-flex>
                                <v-flex xs-8>
                                    <v-textarea
                                        outline
                                        label=""
                                        rows="5"
                                        v-model="zipsSelected"
                                        hint="Click ZIP Block in map, or copy and paste Comma Separated ZIPs here"
                                        persistent-hint
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                    <hr>
                    <!-- <v-layout row >
                        <v-flex xs1>
                            <b>Territory</b>
                        </v-flex>
                        <v-flex xs2>
                            <b>Rep</b>
                        </v-flex>
                        <v-flex xs1 pl-2>
                            <b>12 mo. Sales</b>
                        </v-flex>
                        <v-flex xs7 class="text-xs-center">
                            <b>ZIPS</b>
                        </v-flex>
                    </v-layout> -->
                    <div v-for="trz in tazTerrXRepsXZips" :key="trz.territoryXRepId">
                        <v-layout row>
                            <v-flex xs2>
                                <div class="pa-2">
                                    <v-text-field 
                                        label="Territory"
                                        v-model="trz.territoryId" 
                                        ></v-text-field> 
                                </div>
                                <div class="pa-2">
                                    <v-text-field 
                                        
                                        label="Rep"
                                        v-model="trz.repName" 
                                        ></v-text-field> 
                                    
                                </div>
                                <div>
                                    <b>12 mo. Sales</b>
                                </div>
                                <div>
                                    {{ trz.terrRepSalesAmt | toCurrency}}
                                </div>
                                <div :style="{'background-color': trz.color}">
                                    <b>Map Color</b>
                                </div>
                            </v-flex>
                            <v-flex xs8>                            
                                <span v-for="zipData in trz.zips" :key="zipData.zip" :class="{'warning': zipData.changed}">
                                    {{zipData.zip}}, 
                                </span>
                            </v-flex>
                            <v-flex xs2>                            
                                <v-btn xs color="info" @click="onAssignZips(trz)">Assign ZIPs</v-btn>
                            </v-flex>
                        </v-layout>
                        <hr>

                    </div>
                    <!-- <v-layout row >
                        <v-flex xs1>
                            Not Assigned ZIPS
                        </v-flex>
                        <v-flex xs2>
                            
                        </v-flex>
                        <v-flex xs9>
                            
                        </v-flex>
                    </v-layout> -->
                    <v-layout row>
                        <v-flex>
                            <v-btn @click="onAddNewZipAssignment">Add New Zip Assignment</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row>
                        <v-flex xs12>
                            <h3>If ZIPs reassigned, you can get a report here and email to our Sales Admin.</h3>
                            <v-btn @click="showTerrRepZipsRpt=true" color="primary">Generate a Report</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row>
                        <v-flex xs12>
                            <h3>Do you want to save this map and open it later?</h3>
                            <v-btn @click="onShowSaveTerrRepZipsRpt" color="primary">Save This Map</v-btn>
                        </v-flex>
                    </v-layout>
                    <!-- <v-layout row>
                        <v-flex xs12>
                            <br>
                            <ctlSaveTerrRepZipsRpt @onclose="showTerrRepZipsRpt=false" 
                                :state="paras.state"
                                :tazTerrXRepsXZips="tazTerrXRepsXZips"
                                :savedMapData="savedTerrRepZipsRpt"></ctlSaveTerrRepZipsRpt>
                        </v-flex>
                    </v-layout> -->
                </v-card-text>


            </v-card>
<!-- {{tazTerrXRepsXZips}} -->
<!-- {{zipsSelected}} -->
        </v-container>
        <v-dialog v-model="showTerrRepZipsRpt" width="800" height="600">
            <ctlTerrRepZipsRpt @onclose="showTerrRepZipsRpt=false" 
                :state="paras.state"
                :tazTerrXRepsXZips="tazTerrXRepsXZips"></ctlTerrRepZipsRpt>
        </v-dialog>
        <v-dialog v-model="showSaveTerrRepZipsRpt" width="500" height="400">
            <ctlSaveTerrRepZipsRpt @onclose="showSaveTerrRepZipsRpt=false" 
                :paras="paras"
                :tazTerrXRepsXZips="tazTerrXRepsXZips"
                :savedMapData="savedTerrRepZipsRpt"></ctlSaveTerrRepZipsRpt>
        </v-dialog>

    </div>
</template>
<script>
//!!!!!!!!!!!!! tools !!!!!!!!!!!!!!!!!
// 
//https://googlemaps.github.io/v3-utility-library/
//http://bl.ocks.org/zross/9893056  - Using geojson with Google Maps API
//
//https://github.com/OpenDataDE/State-zip-code-GeoJSON - i downloaded 50 states zips here
//https://github.com/jgoodall/us-maps/tree/master/geojson - more geojson files
//
//!!!!!!!!!!!!! tools !!!!!!!!!!!!!!!!!

import { mapGetters, mapActions } from 'vuex'
import gmapsInit from '@/services/gmaps'
import ctlHomeNav from '@/components/ctlHomeNav'
import ctlTerrRepZipsRpt from '@/components/tools/ctlTerrRepZipsRpt'
import ctlSaveTerrRepZipsRpt from '@/components/tools/ctlSaveTerrRepZipsRpt'
// import MarkerClusterer from '@google/markerclusterer'
// function InfoBox(t){t=t||{},google.maps.OverlayView.apply(this,arguments),this.content_=t.content||"",this.disableAutoPan_=t.disableAutoPan||!1,this.maxWidth_=t.maxWidth||0,this.pixelOffset_=t.pixelOffset||new google.maps.Size(0,0),this.position_=t.position||new google.maps.LatLng(0,0),this.zIndex_=t.zIndex||null,this.boxClass_=t.boxClass||"infoBox",this.boxStyle_=t.boxStyle||{},this.closeBoxMargin_=t.closeBoxMargin||"2px",this.closeBoxURL_=t.closeBoxURL||"//www.google.com/intl/en_us/mapfiles/close.gif",""===t.closeBoxURL&&(this.closeBoxURL_=""),this.closeBoxTitle_=t.closeBoxTitle||" Close ",this.infoBoxClearance_=t.infoBoxClearance||new google.maps.Size(1,1),void 0===t.visible&&(void 0===t.isHidden?t.visible=!0:t.visible=!t.isHidden),this.isHidden_=!t.visible,this.alignBottom_=t.alignBottom||!1,this.pane_=t.pane||"floatPane",this.enableEventPropagation_=t.enableEventPropagation||!1,this.div_=null,this.closeListener_=null,this.moveListener_=null,this.contextListener_=null,this.eventListeners_=null,this.fixedWidthSet_=null}InfoBox.prototype=new google.maps.OverlayView,InfoBox.prototype.createInfoBoxDiv_=function(){var t,i,e,o=this,s=function(t){t.cancelBubble=!0,t.stopPropagation&&t.stopPropagation()};if(!this.div_){if(this.div_=document.createElement("div"),this.setBoxStyle_(),void 0===this.content_.nodeType?this.div_.innerHTML=this.getCloseBoxImg_()+this.content_:(this.div_.innerHTML=this.getCloseBoxImg_(),this.div_.appendChild(this.content_)),this.getPanes()[this.pane_].appendChild(this.div_),this.addClickHandler_(),this.div_.style.width?this.fixedWidthSet_=!0:0!==this.maxWidth_&&this.div_.offsetWidth>this.maxWidth_?(this.div_.style.width=this.maxWidth_,this.div_.style.overflow="auto",this.fixedWidthSet_=!0):(e=this.getBoxWidths_(),this.div_.style.width=this.div_.offsetWidth-e.left-e.right+"px",this.fixedWidthSet_=!1),this.panBox_(this.disableAutoPan_),!this.enableEventPropagation_){for(this.eventListeners_=[],i=["mousedown","mouseover","mouseout","mouseup","click","dblclick","touchstart","touchend","touchmove"],t=0;t<i.length;t++)this.eventListeners_.push(google.maps.event.addDomListener(this.div_,i[t],s));this.eventListeners_.push(google.maps.event.addDomListener(this.div_,"mouseover",function(t){this.style.cursor="default"}))}this.contextListener_=google.maps.event.addDomListener(this.div_,"contextmenu",function(t){t.returnValue=!1,t.preventDefault&&t.preventDefault(),o.enableEventPropagation_||s(t)}),google.maps.event.trigger(this,"domready")}},InfoBox.prototype.getCloseBoxImg_=function(){var t="";return""!==this.closeBoxURL_&&(t="<img",t+=" src='"+this.closeBoxURL_+"'",t+=" align=right",t+=" title='"+this.closeBoxTitle_+"'",t+=" style='",t+=" position: relative;",t+=" cursor: pointer;",t+=" margin: "+this.closeBoxMargin_+";",t+="'>"),t},InfoBox.prototype.addClickHandler_=function(){var t;""!==this.closeBoxURL_?(t=this.div_.firstChild,this.closeListener_=google.maps.event.addDomListener(t,"click",this.getCloseClickHandler_())):this.closeListener_=null},InfoBox.prototype.getCloseClickHandler_=function(){var t=this;return function(i){i.cancelBubble=!0,i.stopPropagation&&i.stopPropagation(),google.maps.event.trigger(t,"closeclick"),t.close()}},InfoBox.prototype.panBox_=function(t){var i,e=0,o=0;if(!t&&(i=this.getMap())instanceof google.maps.Map){i.getBounds().contains(this.position_)||i.setCenter(this.position_);var s=this.pixelOffset_.width,n=this.pixelOffset_.height,h=this.div_.offsetWidth,l=this.div_.offsetHeight,d=this.infoBoxClearance_.width,r=this.infoBoxClearance_.height;if(2==i.panToBounds.length){var a={left:0,right:0,top:0,bottom:0};a.left=-s+d,a.right=s+h+d,this.alignBottom_?(a.top=-n+r+l,a.bottom=n+r):(a.top=-n+r,a.bottom=n+l+r),i.panToBounds(new google.maps.LatLngBounds(this.position_),a)}else{var _=i.getDiv(),p=_.offsetWidth,v=_.offsetHeight,f=this.getProjection().fromLatLngToContainerPixel(this.position_);if(f.x<-s+d?e=f.x+s-d:f.x+h+s+d>p&&(e=f.x+h+s+d-p),this.alignBottom_?f.y<-n+r+l?o=f.y+n-r-l:f.y+n+r>v&&(o=f.y+n+r-v):f.y<-n+r?o=f.y+n-r:f.y+l+n+r>v&&(o=f.y+l+n+r-v),0!==e||0!==o){i.getCenter();i.panBy(e,o)}}}},InfoBox.prototype.setBoxStyle_=function(){var t,i;if(this.div_){for(t in this.div_.className=this.boxClass_,this.div_.style.cssText="",i=this.boxStyle_)i.hasOwnProperty(t)&&(this.div_.style[t]=i[t]);(void 0===this.div_.style.WebkitTransform||-1===this.div_.style.WebkitTransform.indexOf("translateZ")&&-1===this.div_.style.WebkitTransform.indexOf("matrix"))&&(this.div_.style.WebkitTransform="translateZ(0)"),void 0!==this.div_.style.opacity&&""!==this.div_.style.opacity&&(this.div_.style.MsFilter='"progid:DXImageTransform.Microsoft.Alpha(Opacity='+100*this.div_.style.opacity+')"',this.div_.style.filter="alpha(opacity="+100*this.div_.style.opacity+")"),this.div_.style.position="absolute",this.div_.style.visibility="hidden",null!==this.zIndex_&&(this.div_.style.zIndex=this.zIndex_)}},InfoBox.prototype.getBoxWidths_=function(){var t,i={top:0,bottom:0,left:0,right:0},e=this.div_;return document.defaultView&&document.defaultView.getComputedStyle?(t=e.ownerDocument.defaultView.getComputedStyle(e,""))&&(i.top=parseInt(t.borderTopWidth,10)||0,i.bottom=parseInt(t.borderBottomWidth,10)||0,i.left=parseInt(t.borderLeftWidth,10)||0,i.right=parseInt(t.borderRightWidth,10)||0):document.documentElement.currentStyle&&e.currentStyle&&(i.top=parseInt(e.currentStyle.borderTopWidth,10)||0,i.bottom=parseInt(e.currentStyle.borderBottomWidth,10)||0,i.left=parseInt(e.currentStyle.borderLeftWidth,10)||0,i.right=parseInt(e.currentStyle.borderRightWidth,10)||0),i},InfoBox.prototype.onRemove=function(){this.div_&&(this.div_.parentNode.removeChild(this.div_),this.div_=null)},InfoBox.prototype.draw=function(){this.createInfoBoxDiv_();var t=this.getProjection().fromLatLngToDivPixel(this.position_);this.div_.style.left=t.x+this.pixelOffset_.width+"px",this.alignBottom_?this.div_.style.bottom=-(t.y+this.pixelOffset_.height)+"px":this.div_.style.top=t.y+this.pixelOffset_.height+"px",this.isHidden_?this.div_.style.visibility="hidden":this.div_.style.visibility="visible"},InfoBox.prototype.setOptions=function(t){void 0!==t.boxClass&&(this.boxClass_=t.boxClass,this.setBoxStyle_()),void 0!==t.boxStyle&&(this.boxStyle_=t.boxStyle,this.setBoxStyle_()),void 0!==t.content&&this.setContent(t.content),void 0!==t.disableAutoPan&&(this.disableAutoPan_=t.disableAutoPan),void 0!==t.maxWidth&&(this.maxWidth_=t.maxWidth),void 0!==t.pixelOffset&&(this.pixelOffset_=t.pixelOffset),void 0!==t.alignBottom&&(this.alignBottom_=t.alignBottom),void 0!==t.position&&this.setPosition(t.position),void 0!==t.zIndex&&this.setZIndex(t.zIndex),void 0!==t.closeBoxMargin&&(this.closeBoxMargin_=t.closeBoxMargin),void 0!==t.closeBoxURL&&(this.closeBoxURL_=t.closeBoxURL),void 0!==t.closeBoxTitle&&(this.closeBoxTitle_=t.closeBoxTitle),void 0!==t.infoBoxClearance&&(this.infoBoxClearance_=t.infoBoxClearance),void 0!==t.isHidden&&(this.isHidden_=t.isHidden),void 0!==t.visible&&(this.isHidden_=!t.visible),void 0!==t.enableEventPropagation&&(this.enableEventPropagation_=t.enableEventPropagation),this.div_&&this.draw()},InfoBox.prototype.setContent=function(t){this.content_=t,this.div_&&(this.closeListener_&&(google.maps.event.removeListener(this.closeListener_),this.closeListener_=null),this.fixedWidthSet_||(this.div_.style.width=""),void 0===t.nodeType?this.div_.innerHTML=this.getCloseBoxImg_()+t:(this.div_.innerHTML=this.getCloseBoxImg_(),this.div_.appendChild(t)),this.fixedWidthSet_||(this.div_.style.width=this.div_.offsetWidth+"px",void 0===t.nodeType?this.div_.innerHTML=this.getCloseBoxImg_()+t:(this.div_.innerHTML=this.getCloseBoxImg_(),this.div_.appendChild(t))),this.addClickHandler_()),google.maps.event.trigger(this,"content_changed")},InfoBox.prototype.setPosition=function(t){this.position_=t,this.div_&&this.draw(),google.maps.event.trigger(this,"position_changed")},InfoBox.prototype.setZIndex=function(t){this.zIndex_=t,this.div_&&(this.div_.style.zIndex=t),google.maps.event.trigger(this,"zindex_changed")},InfoBox.prototype.setVisible=function(t){this.isHidden_=!t,this.div_&&(this.div_.style.visibility=this.isHidden_?"hidden":"visible")},InfoBox.prototype.getContent=function(){return this.content_},InfoBox.prototype.getPosition=function(){return this.position_},InfoBox.prototype.getZIndex=function(){return this.zIndex_},InfoBox.prototype.getVisible=function(){return void 0!==this.getMap()&&null!==this.getMap()&&!this.isHidden_},InfoBox.prototype.getWidth=function(){var t=null;return this.div_&&(t=this.div_.offsetWidth),t},InfoBox.prototype.getHeight=function(){var t=null;return this.div_&&(t=this.div_.offsetHeight),t},InfoBox.prototype.show=function(){this.isHidden_=!1,this.div_&&(this.div_.style.visibility="visible")},InfoBox.prototype.hide=function(){this.isHidden_=!0,this.div_&&(this.div_.style.visibility="hidden")},InfoBox.prototype.open=function(t,i){var e=this;i&&(this.setPosition(i.getPosition()),this.moveListener_=google.maps.event.addListener(i,"position_changed",function(){e.setPosition(this.getPosition())})),this.setMap(t),this.div_&&this.panBox_(this.disableAutoPan_)},InfoBox.prototype.close=function(){var t;if(this.closeListener_&&(google.maps.event.removeListener(this.closeListener_),this.closeListener_=null),this.eventListeners_){for(t=0;t<this.eventListeners_.length;t++)google.maps.event.removeListener(this.eventListeners_[t]);this.eventListeners_=null}this.moveListener_&&(google.maps.event.removeListener(this.moveListener_),this.moveListener_=null),this.contextListener_&&(google.maps.event.removeListener(this.contextListener_),this.contextListener_=null),this.setMap(null)};
export default {
    components: {
        ctlHomeNav,
        ctlTerrRepZipsRpt,
        ctlSaveTerrRepZipsRpt,
    },

    data: () => ({
        paras: {
            state: 'MI',
            territory: null,
            territoryTypeInMap: 'Standard', // 'GI',    //
        },
        locations: [],
        territories: [],
        usStates: [],
        zipsSelected: '',
        tazTerrXRepsXZips: [],
        map_colors: [],
        zipGeoJsons: {},
        showTerrRepZipsRpt: false,
        showSaveTerrRepZipsRpt: false,
        savedTerrRepZipsRpt: {},
    }),
    computed: {
        ...mapGetters('auth', [
            'userData',
        ]),
        loginInfo () {
            if (this.loggedIn) {
            return `Welcome, ${this.userData.fullName}`
            }
        },
        id () {
            return this.$route.params.id?this.$route.params.id : null
        },
        isNew () {
            return !this.id
        },
    },
    methods: {
        ...mapActions('tazApi', [
            'getFacilitiesForMap',
            'getRepListByZipCodeReport',
            'getTerrZipGeoJson',
            'loadSavedMap',
        ]),
        // -------------- saved map functions
        onShowSaveTerrRepZipsRpt() {
            // override data
            this.showSaveTerrRepZipsRpt = Object.assign(this.savedTerrRepZipsRpt, {
                // id: 
                // name: 
                jsonData: this.tazTerrXRepsXZips,
                // notes: 
                updateBy: this.userData.fullName,
                active: true,
                paras: this.paras,

            })
            this.showSaveTerrRepZipsRpt = true
        },
        // populate Save Map here
        async loadSavedMapData() {
            this.savedTerrRepZipsRpt = await this.loadSavedMap(this.id)
             this.paras = this.savedTerrRepZipsRpt.paras 

            await this.onGetTerrZipGeoJson()
            await this.onSearchFacilities()

            // now we have data ready. we apply saved map to map data
            // json data here is this.tazTerrXRepsXZips (saved last time)
            for(var trzIdx=0; trzIdx < this.savedTerrRepZipsRpt.jsonData.length; trzIdx++) {
                const trz = this.savedTerrRepZipsRpt.jsonData[trzIdx]
                for(var zipIdx=0; zipIdx < trz.zips.length; zipIdx++) {
                    const zipData = trz.zips[zipIdx]

                    let geoJsonZip = this.getGeoJsonByZip(zipData.zip)
                    if(geoJsonZip) {
                        // console.log(trz)
                        let zipProps = geoJsonZip.properties
                        zipProps["terr"] = trz.territoryId;
                        zipProps["rep"] = trz.repName;
                        zipProps["terrRepId"] = trz.territoryXRepId;
                        zipProps["color"] = trz.color;
                        // flag for report
                        zipProps["changed"] = zipData.changed;
                        // zipProps["salesAmt"] = trz.salesAmt;

                        // territoryXRepId: zipGeoJson.properties.terrRepId,
                        // territoryId: zipGeoJson.properties.terr,
                        // // repId: zipGeoJson.properties.terrRepId
                        // repName: zipGeoJson.properties.rep,
                        // color: zipGeoJson.properties.color,
                    }
                }
            }
            this.tazTerrXRepsXZips = this.savedTerrRepZipsRpt.jsonData

            this.generateMap()

        },
        // -------------- end saved map functions


        onAddNewZipAssignment() {
            this.tazTerrXRepsXZips.push({
                territoryId: '??', 
                repName: '??', 
                territoryXRepId: this.tazTerrXRepsXZips.length,
                zips: [],
                color: this.map_colors[this.tazTerrXRepsXZips.length]})
        },
        onAssignZips(trz) {
            if(!this.zipsSelected) {
                alert('ZIPs To Reassign cannot be empty!')
                return
            }

            let zipArray = this.zipsSelected.split(',')

            for (var i=0; i<zipArray.length; i++){
                let z = zipArray[i].replace(' ', '')
                    

                if(z) {
                    let geoJsonZip = this.getGeoJsonByZip(z)
                    if(geoJsonZip) {
                        // console.log(trz)
                        let zipProps = geoJsonZip.properties
                        zipProps["terr"] = trz.territoryId;
                        zipProps["rep"] = trz.repName;
                        zipProps["terrRepId"] = trz.territoryXRepId;
                        zipProps["color"] = trz.color;
                        // flag for report
                        zipProps["changed"] = true;
                        // zipProps["salesAmt"] = trz.salesAmt;

                        // territoryXRepId: zipGeoJson.properties.terrRepId,
                        // territoryId: zipGeoJson.properties.terr,
                        // // repId: zipGeoJson.properties.terrRepId
                        // repName: zipGeoJson.properties.rep,
                        // color: zipGeoJson.properties.color,
                    }
                    // console.log('changed:')
                    // console.log(geoJsonZip)
                }
            }

            //reset zipsSelected
            this.zipsSelected = ''

            this.generateMap()

            this.populateTerrRepZipEditData()
        },
        getGeoJsonByZip(zip) {
            // console.log(zip)
            var zipsFound = this.zipGeoJsons.features.find(p=>p.properties.ZCTA5CE10 == zip)
            // console.log(zipsFound)
            if(zipsFound) { // && zipsFound.length > 0) {
                return zipsFound
            }
            return null
        },
        async onGetTerrZipGeoJson() {
            const rptParas = {
                rptType: 'html',
                state: this.paras.state,
                terrType: this.paras.territoryTypeInMap,
            }

            this.zipGeoJsons = await this.getTerrZipGeoJson(rptParas);
            // console.log(this.zipGeoJsons)
            if(this.zipGeoJsons == null) {
                // it means the login auth time out, go to login
                this.$router.push('/')
            }
            // this.locations = rpt.markers
            // this.territories = rpt.territories

            // await this.onGetRepListByZipCodeReport()

            // this.generateMap()
        },
        async onPopulateMap() {

            await this.onGetTerrZipGeoJson()
            await this.onSearchFacilities()

            this.generateMap()

            this.populateTerrRepZipEditData()
        },
        async onSearchFacilities() {
            var rpt = await this.getFacilitiesForMap(this.paras);
            this.locations = rpt.markers
            this.territories = rpt.territories

            // await this.onGetRepListByZipCodeReport()

            // this.generateMap()
        },
        populateTerrRepZipEditData() {
            //reset
            this.tazTerrXRepsXZips = [];

            let terrReps = new Map()
            if(!this.zipGeoJsons.features) {
                return terrReps
            }

            //start generate terrrep-zips edit data
            for(let zipGeoJson of this.zipGeoJsons.features){
                let terrRepId = zipGeoJson.properties.terrRepId
                if(!terrRepId) {
                    continue
                }
                if(!terrReps.has(terrRepId)) {
                    terrReps.set(terrRepId, {
                        territoryXRepId: zipGeoJson.properties.terrRepId,
                        territoryId: zipGeoJson.properties.terr,
                        // repId: zipGeoJson.properties.terrRepId
                        repName: zipGeoJson.properties.rep,
                        color: zipGeoJson.properties.color,
                        zips: [],
                        terrRepSalesAmt: 0,
                        
                    })
                }
                let terrRep = terrReps.get(terrRepId)
                terrRep.zips.push({
                    zip: zipGeoJson.properties.ZCTA5CE10,
                    salesAmt: zipGeoJson.properties.salesAmt,
                    changed: zipGeoJson.properties.changed,
                })
                if(zipGeoJson.properties.salesAmt) {
                    terrRep.terrRepSalesAmt += zipGeoJson.properties.salesAmt
                }

            }

            this.tazTerrXRepsXZips = [...terrReps.values()]
            for(let trz of this.tazTerrXRepsXZips) {
                trz.zips = trz.zips.sort((a, b)=>a.zip > b.zip? 1 : a.zip < b.zip? -1 : 0)
            }
        },
        // async onGetRepListByZipCodeReport() {
        //     const rptParas = {
        //         rptType: 'html',
        //         state: this.paras.state,
        //         terrType: this.territoryTypeInMap,
        //     }
        //     const tazZipTerrMappingRpt = await this.getRepListByZipCodeReport(rptParas)
        //     if(tazZipTerrMappingRpt == null) {
        //         // it means the login auth time out, go to login
        //         this.$router.push('/')
        //     }
        //     this.tazTerrXRepsXZips = [] //reset
        //     //filter data here
        //     for(var i=0; i< tazZipTerrMappingRpt.states.length; i++) {
        //         let st = tazZipTerrMappingRpt.states[i]
        //         for(var j=0; j < st.terrXReps.length; j++) {
        //             let terrXRep = st.terrXReps[j];
        //             this.tazTerrXRepsXZips.push(terrXRep)
        //             // console.log(terrXRep)
        //             // if(this.territoryTypeInMap == 'GI') {
        //             //     if(terrXRep.territoryId.includes('GI')) {
        //             //         this.tazTerrXRepsXZips.push(terrXRep)
        //             //     }
        //             // } else {    // standard terr type
        //             //     if(!terrXRep.territoryId.includes('GI')) {
        //             //         this.tazTerrXRepsXZips.push(terrXRep)
        //             //     }

        //             // }
        //         }
        //     } 
        // },
        // addExtraDataToFeature(feature) {
        //     let zip = feature.h.ZCTA5CE10
        //     if(zip) {
        //         for(var i = 0; i < this.tazTerrXRepsXZips.length; i++) {
        //             let terrXRep = this.tazTerrXRepsXZips[i]
        //             if(terrXRep.zipsStr.includes(zip)) {
        //                 feature['color'] = this.map_colors[i]
        //                 // console.log(zip + ' - ' + feature['color'])
        //                 feature['terr'] = terrXRep.territoryId
        //                 feature['rep'] = terrXRep.repName
        //             } 
        //         }
        //     }
        // },
        async generateMap() {
            try {
                const google = await gmapsInit();
                // const geocoder = new google.maps.Geocoder();
                // const map = new google.maps.Map(this.$el);
                var divmap = document.getElementById("divmap")
                const map = new google.maps.Map(divmap);

                // geocoder.geocode({ address: `US` }, (results, status) => {
                //     if (status !== `OK` || !results[0]) {
                //     throw new Error(status);
                //     }
                //     map.setCenter(results[0].geometry.location);
                //     map.fitBounds(results[0].geometry.viewport);
                // });

                //set map area / center automatically
                var bounds  = new google.maps.LatLngBounds();
                for(var i = 0; i < this.locations.length; i++) {
                    bounds.extend(this.locations[i].position);

                }
                map.fitBounds(bounds);

                // loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

                const markerClickHandler = (marker) => {
                    map.setZoom(13);
                    map.setCenter(marker.getPosition());
                };
                const markers = this.locations
                    .map((location) => {
                        const marker = new google.maps.Marker({ ...location, map });
                        marker['infowindow'] = new google.maps.InfoWindow({
                                content: `<div><b>${location.metaData.code} of ${location.metaData.territory}</b></div><div>${location.title}</div><div>${location.metaData.address}</div><div>\$${location.metaData.salesAmt? location.metaData.salesAmt.toFixed(2) : 0}</div>`
                            });

                        marker.addListener('mouseover', function() {
                            this['infowindow'].open(map, this);
                        });
                        marker.addListener('mouseout', function() {
                            this['infowindow'].close();
                        });
                        // marker.addListener(`click`, () => markerClickHandler(marker));
                        return marker;
                    });
                // eslint-disable-next-line no-new
                // new MarkerClusterer(map, markers, {
                //     imagePath: `https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m`,
                // });

                const that = this
                //zip data layer code
                map.data.setStyle(function(feature) {
                    // var zip = feature.getProperty('ZCTA5CE10')
                    var zipColor = feature.getProperty('color')
                    //that.addExtraDataToFeature(feature)
                    return {
                        fillColor: zipColor? zipColor : 'lightblue',
                        strokeWeight: .5,
                        // label: {
                        //     color: "lightblue",
                        //     fontFamily: "Courier",
                        //     fontSize: "24px",
                        //     fontWeight: "bold",
                        //     text: zip
                        // }
                    }
                });

                //20201108, stop load raw zip geojson
                // if(this.paras.state == 'IL') {
                //     map.data.loadGeoJson(
                //         "https://raw.githubusercontent.com/OpenDataDE/State-zip-code-GeoJSON/master/il_illinois_zip_codes_geo.min.json"
                //     );

                // } else {
                //     map.data.loadGeoJson(
                //         "https://raw.githubusercontent.com/OpenDataDE/State-zip-code-GeoJSON/master/mi_michigan_zip_codes_geo.min.json"
                //     );

                // }

                //new way to get from taz with HM business data embedded
                map.data.addGeoJson(this.zipGeoJsons)

                map.data.addListener('mouseover', function(event) {
                    // console.log(event)
                    const infoWindow = new google.maps.InfoWindow({
                                content: `<div><b>${event.feature.h.ZCTA5CE10} </b></div>
                                <div><b>${event.feature.h.terr} </b></div>
                                <div><b>${event.feature.h.rep} </b></div>
                                <div>\$${event.feature.h.salesAmt? event.feature.h.salesAmt : 0 }</div>`
                            });
                    event.feature['infoWindow'] = infoWindow
                    // infoWindow.setContent('<div style="line-height:1.35;overflow:hidden;white-space:nowrap;"> Feature id = '+
                    //                             event.feature.getId() +"<br/>Feature Value = Zone " + event.feature.getProperty("value") + "</div>");
                    var anchor = new google.maps.MVCObject();
                    anchor.set("position",event.latLng);
                    infoWindow.open(map,anchor);
                });
                map.data.addListener('mouseout', function(event) {
                    event.feature['infoWindow'].close();
                });
                // marker['infowindow'] = new google.maps.InfoWindow({
                //         content: `<div><b>${location.metaData.code} of ${location.metaData.territory}</b></div><div>${location.title}</div><div>${location.metaData.address}</div><div>${location.position.lat} - ${location.position.lng}</div>`
                //     });

                // marker.addListener('mouseover', function() {
                //     this['infowindow'].open(map, this);
                // });
                // marker.addListener('mouseout', function() {
                //     this['infowindow'].close();
                // });
                // Set the fill color to red when the feature is clicked.
                // Stroke weight remains 3.
                map.data.addListener('click', function(event) {
                    // alert('zip ' + event.feature.h.ZCTA5CE10 + ' selected!')
                    map.data.overrideStyle(event.feature, {fillColor: 'grey'});
                    // that.zipsSelected.push(event.feature.h.ZCTA5CE10)
                    that.zipsSelected += event.feature.h.ZCTA5CE10 + ', '
                });
                map.data.addListener('addfeature', function(evt) {
                    if (evt.feature.h.ZCTA5CE10) {
                        // console.log(evt.feature.h.ZCTA5CE10)
                        // console.log(evt.feature.h.INTPTLON10)
                        // console.log(evt.feature.h.INTPTLAT10)
                        var coord = {lng: parseFloat(evt.feature.h.INTPTLON10), lat: parseFloat(evt.feature.h.INTPTLAT10)} // evt.feature.getGeometry().get();
                        // console.log(coord)
                        bounds.extend(coord);
                        map.fitBounds(bounds);
                        var labelText = evt.feature.h.ZCTA5CE10; //evt.feature.getProperty("Name");
                        var labelDiv = document.createElement("div");
                        labelDiv.innerHTML = labelText;
                        labelDiv.setAttribute("id", "label");

                        var myOptions = {
                            content: labelDiv,
                            boxStyle: {
                            border: "none",
                            textAlign: "center",
                            width: "50px"
                            },
                            disableAutoPan: true,
                            pixelOffset: new google.maps.Size(-25, 0),
                            position: coord,
                            closeBoxURL: "",
                            isHidden: false,
                            pane: "mapPane",
                            enableEventPropagation: true
                        };

                        // var ibLabel = new InfoBox(myOptions);
                        // ibLabel.open(map);

                        // var marker = new google.maps.Marker({
                        //     position: coord, // new google.maps.LatLng(0, 0),
                        //     icon: '',    //'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
                        //     label: { color: '#00aaff', fontWeight: 'normal', fontSize: '10px', text: 'ZIPs' },
                        //     optimized: false,
                        //     visible: true
                        // });
                        // marker.setMap(map);
                    }
                    // if (evt.feature.getGeometry().getType() == "Point") {


                    // var coord = evt.feature.getGeometry().get();
                    // bounds.extend(coord);
                    // map.fitBounds(bounds);
                    // var labelText = evt.feature.getProperty("Name");
                    // var labelDiv = document.createElement("div");
                    // labelDiv.innerHTML = labelText;
                    // labelDiv.setAttribute("id", "label");

                    // var myOptions = {
                    //     content: labelDiv,
                    //     boxStyle: {
                    //     border: "none",
                    //     textAlign: "center",
                    //     width: "50px"
                    //     },
                    //     disableAutoPan: true,
                    //     pixelOffset: new google.maps.Size(-25, 0),
                    //     position: coord,
                    //     closeBoxURL: "",
                    //     isHidden: false,
                    //     pane: "mapPane",
                    //     enableEventPropagation: true
                    // };

                    // var ibLabel = new InfoBox(myOptions);
                    // ibLabel.open(map);
                    // }
                });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        },
        
    },
    async mounted() {
        // this.usStates = [{name: "All States", abbreviation: ""}, ...this.allUsStates()]
        this.usStates = this.allUsStates()
        // await this.onGetTerrZipGeoJson()
        // await this.onSearchFacilities()
        // await this.onPopulateMap()
        if(!this.isNew) {
            await this.loadSavedMapData()
        }
        this.map_colors = [
            '#00FFFF',
            '#DA70D6',
            '#8B0000',
            '#FA8072',
            '#1E90FF',
            '#00FF00',
            '#FFA07A',
            '#E9967A',
            '#F08080',
            '#CD5C5C',
            '#DC143C',
            '#B22222',
            '#FF0000',
            '#FF7F50',
            '#FF6347',
            '#FF4500',
            '#FFD700',
            '#FFA500',
            '#FF8C00',
            '#EEE8AA',
            '#F0E68C',
            '#BDB76B',
            '#FFFF00',
            '#7CFC00',
            '#7FFF00',
            '#32CD32',
            '#228B22',
            '#008000',
            '#006400',
            '#ADFF2F',
            '#9ACD32',
            '#00FF7F',
            '#00FA9A',
            '#90EE90',
            '#98FB98',
            '#8FBC8F',
            '#3CB371',
            '#2E8B57',
            '#808000',
            '#556B2F',
            '#6B8E23',
            '#E6E6FA',
            '#D8BFD8',
            '#DDA0DD',
            '#EE82EE',
            '#FF00FF',
            '#FF00FF',
            '#BA55D3',
            '#9370DB',
            '#8A2BE2',
            '#9400D3',
            '#9932CC',
            '#8B008B',
            '#800080',
            '#4B0082',
            '#FFC0CB',
            '#FFB6C1',
            '#FF69B4',
            '#FF1493',
            '#DB7093',
            '#C71585',
            '#FFFFFF',
            '#FFFAFA',
            '#F0FFF0',
            '#F5FFFA',
            '#F0FFFF',
            '#F0F8FF',
            '#F8F8FF',
            '#F5F5F5',
            '#FFF5EE',
            '#F5F5DC',
            '#FDF5E6',
            '#FFFAF0',
            '#FFFFF0',
            '#FAEBD7',
            '#FAF0E6',
            '#FFF0F5',
            '#FFE4E1',
            '#DCDCDC',
            '#D3D3D3',
            '#C0C0C0',
            '#A9A9A9',
            '#808080',
            '#696969',
            '#778899',
            '#708090',
            '#2F4F4F',
            '#000000',
            '#FFF8DC',
            '#FFEBCD',
            '#FFE4C4',
            '#FFDEAD',
            '#F5DEB3',
            '#DEB887',
            '#D2B48C',
            '#BC8F8F',
            '#F4A460',
            '#DAA520',
            '#CD853F',
            '#D2691E',
            '#8B4513',
            '#A0522D',
            '#A52A2A',
            '#800000',
            '#E0FFFF',
            '#00FFFF',
            '#7FFFD4',
            '#66CDAA',
            '#AFEEEE',
            '#40E0D0',
            '#48D1CC',
            '#00CED1',
            '#20B2AA',
            '#5F9EA0',
            '#008B8B',
            '#008080',
            '#B0E0E6',
            '#ADD8E6',
            '#87CEFA',
            '#87CEEB',
            '#00BFFF',
            '#B0C4DE',
            '#6495ED',
            '#4682B4',
            '#4169E1',
            '#0000FF',
            '#0000CD',
            '#00008B',
            '#000080',
            '#191970',
            '#7B68EE',
            '#6A5ACD',
            '#483D8B',
        ]
    },
    // async mounted() {
    //     const google = await gmapsInit();
    //     const geocoder = new google.maps.Geocoder();
    //     // const map = new google.maps.Map(this.$el);
    //     var divmap = document.getElementById("divmap")
    //     const map = new google.maps.Map(divmap);

    //     geocoder.geocode({ address: 'Austria' }, (results, status) => {
    //         if (status !== 'OK' || !results[0]) {
    //         throw new Error(status);
    //         }

    //         map.setCenter(results[0].geometry.location);
    //         map.fitBounds(results[0].geometry.viewport);
    //     });
    //     try {
    //     } catch (error) {
    //     console.error(error);
    //     }
    // },

}
</script>
<style>
/* html,
body {
  margin: 0;
  padding: 0;
} */

.App {
  width: auto;
  height: 100vh;
}
.aaa {
    color:  
            #00FFFF,
            #DA70D6,
            #8B0000,
            #FA8072,
            #1E90FF,
            #00FF00,
            #FFA07A,
            #E9967A,
            #F08080,
            #CD5C5C,
            #DC143C,
            #B22222,
            #FF0000,
            #FF7F50,
            #FF6347,
            #FF4500,
            #FFD700,
            #FFA500,
            #FF8C00,
            #EEE8AA,
            #F0E68C,
            #BDB76B,
            #FFFF00,
            #7CFC00,
            #7FFF00,
            #32CD32,
            #228B22,
            #008000,
            #006400,
            #ADFF2F,
            #9ACD32,
            #00FF7F,
            #00FA9A,
            #90EE90,
            #98FB98,
            #8FBC8F,
            #3CB371,
            #2E8B57,
            #808000,
            #556B2F,
            #6B8E23,
            #E6E6FA,
            #D8BFD8,
            #DDA0DD,
            #EE82EE,
            #FF00FF,
            #FF00FF,
            #BA55D3,
            #9370DB,
            #8A2BE2,
            #9400D3,
            #9932CC,
            #8B008B,
            #800080,
            #4B0082,
            #FFC0CB,
            #FFB6C1,
            #FF69B4,
            #FF1493,
            #DB7093,
            #C71585,
            #FFFFFF,
            #FFFAFA,
            #F0FFF0,
            #F5FFFA,
            #F0FFFF,
            #F0F8FF,
            #F8F8FF,
            #F5F5F5,
            #FFF5EE,
            #F5F5DC,
            #FDF5E6,
            #FFFAF0,
            #FFFFF0,
            #FAEBD7,
            #FAF0E6,
            #FFF0F5,
            #FFE4E1,
            #DCDCDC,
            #D3D3D3,
            #C0C0C0,
            #A9A9A9,
            #808080,
            #696969,
            #778899,
            #708090,
            #2F4F4F,
            #000000,
            #FFF8DC,
            #FFEBCD,
            #FFE4C4,
            #FFDEAD,
            #F5DEB3,
            #DEB887,
            #D2B48C,
            #BC8F8F,
            #F4A460,
            #DAA520,
            #CD853F,
            #D2691E,
            #8B4513,
            #A0522D,
            #A52A2A,
            #800000,
            #E0FFFF,
            #00FFFF,
            #7FFFD4,
            #66CDAA,
            #AFEEEE,
            #40E0D0,
            #48D1CC,
            #00CED1,
            #20B2AA,
            #5F9EA0,
            #008B8B,
            #008080,
            #B0E0E6,
            #ADD8E6,
            #87CEFA,
            #87CEEB,
            #00BFFF,
            #B0C4DE,
            #6495ED,
            #4682B4,
            #4169E1,
            #0000FF,
            #0000CD,
            #00008B,
            #000080,
            #191970,
            #7B68EE,
            #6A5ACD,
            #483D8B,
}
</style>